import { CognitoAuth } from "amazon-cognito-auth-js";

export class SandboxManagementClient {
    endpoint: string;
    auth: CognitoAuth;

    constructor(endpoint: string, auth: CognitoAuth) {
        this.endpoint = endpoint;
        this.auth = auth;
    }
}
